import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { TrustBadges } from './ui/TrustBadges';
export function OfferSection() {
  return <section id="oferta" className="w-full bg-white py-16 px-4 scroll-mt-20" data-id="element-130">
      <div className="max-w-5xl mx-auto" data-id="element-131">
        <div className="text-center mb-12" data-id="element-132">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-133">
            🔥 Aprovecha Esta Oferta Especial
          </h2>
          <p className="text-xl text-slate-600" data-id="element-134">
            Selecciona tu paquete. Pagas al recibir en la puerta de tu casa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-135">
          {/* Card 1: Single */}
          <div className="bg-white rounded-3xl border-2 border-slate-200 p-8 flex flex-col relative shadow-sm hover:shadow-lg transition-shadow" data-id="element-136">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-slate-200 text-slate-700 px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-137">
              Más Popular
            </div>

            <div className="text-center mb-6 mt-4" data-id="element-138">
              <h3 className="text-2xl font-bold text-slate-800 mb-2" data-id="element-139">
                1 Rodillera Térmica
              </h3>
              <div className="flex flex-col items-center justify-center mb-4" data-id="element-140">
                <span className="text-slate-400 line-through text-lg" data-id="element-141">
                  $1,400 MXN
                </span>
                <span className="text-5xl font-black text-slate-900" data-id="element-142">
                  $699<span className="text-2xl" data-id="element-143">MXN</span>
                </span>
              </div>
              <div className="bg-green-100 text-green-800 font-bold py-1 px-3 rounded inline-block" data-id="element-144">
                Ahorras $701 MXN
              </div>
            </div>

            <div className="flex-grow" data-id="element-145"></div>

            <CTAButton text="Comprar 1 Unidad" className="mb-4" data-id="element-146" />
            <TrustBadges data-id="element-147" />
          </div>

          {/* Card 2: Bundle */}
          <div className="bg-blue-50 rounded-3xl border-4 border-blue-600 p-8 flex flex-col relative shadow-xl transform md:scale-105 z-10" data-id="element-148">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white px-6 py-1.5 rounded-full text-sm font-bold uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-149">
              ⭐ Mejor Valor (Recomendado)
            </div>

            <div className="text-center mb-6 mt-4" data-id="element-150">
              <h3 className="text-2xl font-bold text-blue-900 mb-2" data-id="element-151">
                2 Rodilleras Térmicas
              </h3>
              <p className="text-blue-600 font-medium mb-2" data-id="element-152">
                Ideal para ambas rodillas o para regalar
              </p>
              <div className="flex flex-col items-center justify-center mb-4" data-id="element-153">
                <span className="text-slate-400 line-through text-lg" data-id="element-154">
                  $2,800 MXN
                </span>
                <span className="text-5xl font-black text-blue-700" data-id="element-155">
                  $999<span className="text-2xl" data-id="element-156">MXN</span>
                </span>
              </div>
              <div className="bg-green-100 text-green-800 font-bold py-1 px-3 rounded inline-block animate-pulse" data-id="element-157">
                Ahorras $1,801 MXN
              </div>
            </div>

            <div className="flex-grow" data-id="element-158"></div>

            <CTAButton text="Comprar 2 Unidades" className="mb-4" data-id="element-159" />
            <TrustBadges data-id="element-160" />
          </div>
        </div>
      </div>
    </section>;
}